// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__20f4y","itemTitle":"ClientEmergencyInfo_itemTitle__1gymI","itemText":"ClientEmergencyInfo_itemText__1sEcj"};